import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import StationsService from "../../services/StationsService";

// Função utilitária para cor do status
const getStatusColor = (status: string): string => {
  // Atualizado conforme lista fornecida
  const successStatuses = ["created_hiplade", "running"];
  const warningStatuses = ["processing_recording"];
  const errorStatuses = [
    "error_create_streaming_hiplade",
    "error_hiplade_transmition_method",
    "error_hiplade_useffmpeg"
  ];

  if (successStatuses.includes(status)) return "#43a047"; // verde
  if (warningStatuses.includes(status)) return "#ffa726"; // laranja
  if (errorStatuses.includes(status)) return "#e53935"; // vermelho
  return "#757575"; // cinza padrão
};

interface DebriefingStatusWatcherProps {
  status: string;
  debriefingId: any; // Troca stationId/userId por debriefingId
  intervalMs?: number;
  onStatusChange?: (newStatus: string) => void;
}

const DebriefingStatusWatcher: React.FC<DebriefingStatusWatcherProps> = ({
  status,
  debriefingId,
  intervalMs = 3500,
  onStatusChange,
}) => {
  const [checking, setChecking] = useState(false);
  const [cameraStatuses, setCameraStatuses] = useState<any[]>([]);

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;
    if (status === "initializing" || status === "in_simulation") {
      setChecking(true);
      interval = setInterval(async () => {
        try {
          await StationsService.getStreamingsStatusByDebriefing(debriefingId)
            .then((response: any) => {
              const newStatus = response.data.debriefing_status;
              const streamings = Array.isArray(response.data.streamings) ? response.data.streamings : [];
              setCameraStatuses(streamings);
              // Chama onStatusChange se debriefing_status for 'in_simulation' e houver streaming principal 'running'
              if (
                newStatus === "in_simulation" &&
                streamings.some((s: any) => s.status === "running" && s.camera_main === 1)
              ) {
                if (onStatusChange) onStatusChange(newStatus);
                //setChecking(false);
                //window.location.reload();
              }
              if (newStatus !== "initializing" && newStatus !== "in_simulation") {
                if (onStatusChange) onStatusChange(newStatus);
                setChecking(false);
                window.location.reload();
              }

            });
        } catch (e) {
          // Trate erros se necessário
        }
      }, intervalMs);
    } else {
      setChecking(false);
      setCameraStatuses([]);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [status, debriefingId, intervalMs, onStatusChange]);

  if (!checking) return null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: 2 }}>
      {cameraStatuses.length === 0 ? (
        <Typography variant="caption" color="textSecondary">
          Consultando status das câmeras...
        </Typography>
      ) : (
        <Typography variant="caption" color="textSecondary">
          {cameraStatuses.map((cam, idx) => (
            <span key={cam.camera_name || idx} style={{ color: getStatusColor(cam.status) }}>
              {cam.camera_name ? `${cam.camera_name}: ` : ''}{cam.status || 'Desconhecido'}
              {idx < cameraStatuses.length - 1 && ' | '}
            </span>
          ))}
        </Typography>
      )}
    </Box>
  );
};

export default DebriefingStatusWatcher;
